import { lazy } from 'react';

const CustomPlanificationsReportSearcher = lazy(() => import('./CustomPlanificationsReportSearcher'));

export default CustomPlanificationsReportSearcher;
